import { useEffect, useState } from 'react';

const useGeoLocation = () => {
  const [geoData, setGeoData] = useState({
    country: null,
    countryCode: null,
    loading: true,
    error: null,
  });

  useEffect(() => {
    const controller = new AbortController();
    let mounted = true;

    const detectCountry = async () => {
      try {
        const response = await fetch('https://ipapi.co/json/', {
          signal: controller.signal,
        });
        if (!response.ok) {
          throw new Error('Failed to fetch geo data');
        }
        const data = await response.json();

        if (!mounted) return;
        setGeoData({
          country: data.country_name,
          countryCode: data.country_code,
          loading: false,
          error: null,
        });
      } catch (error) {
        if (error.name === 'AbortError' || !mounted) return;

        console.error('Geo detection error:', error);
        setGeoData({
          country: null,
          countryCode: null,
          loading: false,
          error: error.message,
        });
      }
    };

    detectCountry();

    return () => {
      mounted = false;
      controller.abort();
    };
  }, []);

  return geoData;
};

export default useGeoLocation;
